(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shine-pages-image-with-text-4-variant-6"] && !Shopify.designMode) return;
  try {
    
function spFaqToggleHandle(element) {
    const item = element.closest('.sp-faq-question-item');
    const items = document.querySelectorAll('.sp-faq-question-item');
    
    if (item.classList.contains('is-selected')) {
        item.classList.remove('is-selected');
    } else {
        items.forEach(el => {
            el.classList.remove('is-selected');
        });
        item.classList.add('is-selected');
    }
}

  } catch(e) { console.error(e); }
})();
})();
